import { EuiFlexGroup, EuiFlexItem, EuiIcon } from "@inscopix/ideas-eui";
import { ButtonIdentifyFile } from "components/ButtonIdentifyFile/ButtonIdentifyFile";
import { ButtonViewTaskLogsDrsFile } from "components/ButtonViewTaskLogs/ButtonViewTaskLogsForDrsFile";
import { CircularProgress } from "components/CircularProgress/CircularProgress";
import { useGetDrsFileProcessingStatus } from "hooks/useGetDrsFileProcessingStatus";
import { getDrsFileModifyPermissionByDrsFileAndAction } from "types/DrsFileModifyPermissions";
import { FileBrowserFile } from "./FileBrowser";
import { getTagsList } from "utils/getTagsList";
import { FileTag } from "components/FileTag/FileTag";

export interface FileBrowserCellRendererFileTypeProps {
  file: FileBrowserFile;
}

export const FileBrowserCellRendererFileType = ({
  file,
}: FileBrowserCellRendererFileTypeProps) => {
  const { processingStatus } = useGetDrsFileProcessingStatus(file.id);

  const tags = getTagsList(file.tags, [file.fileType]);

  return (
    <EuiFlexGroup
      alignItems="center"
      gutterSize="xs"
      justifyContent="flexStart"
    >
      {processingStatus === "pending" && (
        <EuiIcon
          type={() => (
            <CircularProgress size="xs" color="text" value={100} max={100} />
          )}
        />
      )}

      <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
        {tags.map((tag) => (
          <FileTag key={`${file.id}-${tag}`} tag={tag} />
        ))}
      </span>
      <EuiFlexItem />
      {(() => {
        if (processingStatus === "error") {
          return (
            <ButtonViewTaskLogsDrsFile drsFileId={file.id} color="warning" />
          );
        }
      })()}
      {getDrsFileModifyPermissionByDrsFileAndAction(
        {
          ...file,
        },
        "IDENTIFY",
      ).isPermitted && <ButtonIdentifyFile file={{ ...file }} />}
    </EuiFlexGroup>
  );
};
